import employeeapi from "../../../../services/employee";

export const fetchParticipationTransactionsApi = async (branchId, year, month, currentDate) => {
  const response = await employeeapi.get(
    `ParticipationTransactions/by-branch?branchId=${branchId}&year=${year}&month=${month}&currentDate=${currentDate}`
  );
  return response.data;
};

export const startOperationApi = async (employeeId, startTime) => {
  const response = await employeeapi.post("ParticipationTransactions/start-operation", { employeeId, startTime });
  // The API should return the newly created transaction, including its ID.
  return response.data;
};

export const endOperationApi = async (participationTransactionId, endTime) => {
  const response = await employeeapi.post("ParticipationTransactions/end-operation", { participationTransactionId, endTime });
  return response.data;
};

export const absentApi = async (employeeId, absentAt, description, reasonType) => {
  const response = await employeeapi.post("ParticipationTransactions/absent", { employeeId, absentAt, description, reasonType });
  return response.data;
};
